// src/pages/PostAd/PostAdSuccess.js
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePostAd } from '../../contexts/PostAdContext';
import { FiCheckCircle, FiArrowRight, FiPlusCircle, FiSearch } from 'react-icons/fi';
import './PostAd.css';

const PostAdSuccess = () => {
  const navigate = useNavigate();
  const { adId } = useParams();
  const { resetFlow } = usePostAd();

  const handlePostAnother = () => {
    resetFlow(); // Clear all AI data and photos
    navigate('/postad');
  };

  return (
    <div className="success-page">
      <div className="success-container">
        <div className="success-icon-wrapper">
          <FiCheckCircle size={80} color="#4CAF50" />
        </div>
        
        <h1>Congratulations!</h1>
        <p>Your ad is now live on Qinto. It's visible to buyers in your area.</p>

        <div className="success-actions">
          <button 
            className="action-card primary" 
            onClick={() => navigate(`/item/${adId}`)}
          >
            <div className="action-content">
              <FiArrowRight size={24} />
              <div>
                <span className="action-title">See your ad</span>
                <span className="action-desc">View how buyers see your listing</span>
              </div>
            </div>
          </button>

          <button 
            className="action-card" 
            onClick={() => navigate('/explore')}
          >
            <div className="action-content">
              <FiSearch size={24} />
              <div>
                <span className="action-title">Explore Listings</span>
                <span className="action-desc">Browse other items for sale</span>
              </div>
            </div>
          </button>

          <button 
            className="action-card" 
            onClick={handlePostAnother}
          >
            <div className="action-content">
              <FiPlusCircle size={24} />
              <div>
                <span className="action-title">Post Another Ad</span>
                <span className="action-desc">Sell more items with Qobo Magic</span>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PostAdSuccess;